module.exports = __webpack_public_path__ + "img/IT0000126876530.1412526b.svg";